RELATED_TAB_VALUE